import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import SignIn from "./components/authentication/SignIn";
import SignUp from "./components/authentication/SignUp";
import ResetPassword from "./components/authentication/ResetPassword";
import Marketplace from "./components/marketplace/Marketplace";
import Events from "./components/marketplace/Events";


import AllJobs from "./components/marketplace/AllJobs";
import AllTools from "./components/marketplace/AllTools";


import Tools from "./components/marketplace/Tools";
import Jobs from "./components/marketplace/Jobs";
import MyJobs from "./components/marketplace/MyJobs";
import UserMessage from "./components/marketplace/UserMessage";

import GamesMenu from "./components/marketplace/GamesMenu";
import Profile from "./components/marketplace/Profile";
import Connect from "./components/marketplace/Connect";
import Extras from "./components/marketplace/Extras";

import Workers from "./components/marketplace/Workers";
import Newsletter from "./components/marketplace/Newsletter";
import Share from "./components/marketplace/Share";
import Donate from "./components/marketplace/Donate";
import Weather from "./components/marketplace/Weather";

import AccountDelete from "./components/marketplace/AccountDelete";

import UserProfilePopup from "./components/marketplace/UserProfilePopup";
import AccountPage from "./components/AccountPage";
import AccountSettings from "./components/AccountSettings";
import ManageDomains from "./components/ManageDomains";
import Payments from "./components/Payments";
import EditProfile from './components/EditProfile';

import GeneralArithmeticQuiz from './components/games/arithmetic/GeneralArithmeticQuiz';
import GeneralArithmeticQuizQuestion from './components/games/arithmetic/GeneralArithmeticQuizQuestion';
import GeneralArithmeticQuizResult from './components/games/arithmetic/GeneralArithmeticQuizResult';
import ArithmeticQuiz from './components/games/arithmetic/ArithmeticQuiz';
import ArithmeticQuizQuestion from './components/games/arithmetic/ArithmeticQuizQuestion';
import ArithmeticQuizResult from './components/games/arithmetic/ArithmeticQuizResult';
import ArithmeticGrade7 from './components/games/arithmetic/ArithmeticGrade7';

import EnglishWords from './components/games/language/EnglishWords';
import Dictionary from './components/games/language/Dictionary';
import GeneralPronunciation from './components/games/language/GeneralPronunciation';

import DrawingBoard from './components/games/drawings/DrawingBoard';

import MemoryGame from './components/games/memory/MemoryGame';

import PuzzleGame from './components/games/puzzles/PuzzleGame';

import PhaserGame from './components/games/external/PhaserGame';





function App() {



  return (
    
      <Router>
     
        <Routes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<AccountPage />} />
          
          <Route path="/account-settings" element={<AccountSettings />} />
          <Route path="/manage-domains" element={<ManageDomains />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/edit-profile" element={<EditProfile />} />


	// Arithmetic
          <Route path="/general-arithmetic-quiz" element={<GeneralArithmeticQuiz />} />
          <Route path="/general-arithmetic-quiz-question" element={<GeneralArithmeticQuizQuestion />} />
          <Route path="/general-arithmetic-quiz-result" element={<GeneralArithmeticQuizResult />} />
          <Route path="/arithmetic-quiz" element={<ArithmeticQuiz />} />
          <Route path="/arithmetic-quiz-question" element={<ArithmeticQuizQuestion />} />
          <Route path="/arithmetic-quiz-result" element={<ArithmeticQuizResult />} />
          <Route path="/arithmetic-qrade-seven" element={<ArithmeticGrade7 />} />

          // language
          <Route path="/dictionary" element={<Dictionary />} />
          <Route path="/english-words" element={<EnglishWords />} />
          <Route path="/general-pronunciation" element={<GeneralPronunciation />} />

          //drawings
          <Route path="/drawing-board" element={<DrawingBoard />} />

          //memory
          <Route path="/memory-game" element={<MemoryGame />} />

          //puzzle
          <Route path="/puzzle-game" element={<PuzzleGame />} />

          //external
          <Route path="/external" element={<PhaserGame />} />
    
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/workers" element={<Workers />} />

          <Route path="/extras" element={<Extras />} />
          <Route path="/jobs" element={<Jobs />} />
           <Route path="/all-jobs" element={<AllJobs />} />
          <Route path="/my-jobs" element={<MyJobs />} /> 
          <Route path="/user-message" element={<UserMessage />} /> 
          <Route path="/all-tools" element={<AllTools />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/profile" element={<Profile />} />
          
          <Route path="/events" element={<Events />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/share" element={<Share />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/weather" element={<Weather />} />
	        <Route path="/games" element={<GamesMenu />} />


          <Route path="/delete-account" element={<AccountDelete />} />
          <Route path="/*" element={<AccountPage />} /> {/* Default route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
       
      </Router>
    
  );
}

function NotFound() {
  return (
    <div>
      <h2>404 - Not Found</h2>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
}

export default App;
